import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import useToken from 'hooks/useToken';
import { useToast } from 'context/providers/ToastProvider';

import { Modal, Button, Form, Row, Col, Spinner, InputGroup } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faEye, faEyeSlash, faCloudUploadAlt, faPlus, faFileContract, faKey
} from '@fortawesome/free-solid-svg-icons'

import IconButton from 'components/common/IconButton';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const ModalDatosFiscales = (
    {
        showModalNuevo,
        showModalDatosFiscales,
        setShowModalDatosFiscales,

        datoFiscal,
        setLista,
        lista
    }
) => {

    const cerFileInput = useRef(null);
    const keyFileInput = useRef(null);

    const { showErrorToast } = useToast();

    const [guardando, setGuardando] = useState(false); 
    const { token, setToken } = useToken();
    const [cargando, /*setCargando*/] = useState(false);
    const [editar, setEditar] = useState(false);
    const [regimenesFiscales, setRegimenesFiscales] = useState([]);
    const [showPassword, setShowPassword] = useState(false);
    const [formData, setFormData] = useState({
        idDatoFiscal: 0,
        bIsActive: true,  // <- Valor por defecto para nuevos registros
        vRFC: '',
        vPassword: '',
        vCodeRegimen: '',
        vCP: '',
        vArchivoCER_Base64: '',
        vArchivoCER_Name: '',
        vArchivoKEY_Base64: '',
        vArchivoKEY_Name: '',
        vRazonSocial: '',
        vDescripcionRegimenFiscal: ''
    });
    const [rfcValido, setRfcValido] = useState(true);
    const [rfcTocado, setRfcTocado] = useState(false);
    const [cpValido, setCpValido] = useState(true);
    const [cpTocado, setCpTocado] = useState(false);

    /**
    * Se ejecuta la primera vez
    */
    useEffect(() => {
        obtenerRegimenesFiscales();

        //Esta funcion es para detectar cuando es un modal nuevo o para edicion
        if (showModalNuevo === false) {
            inicializarDatos();
        }
        else {
            abrirModalNuevo();
        }
        
    }, []);

    // Función para abrir modal en modo EDICION
    const inicializarDatos = () => {
        setFormData(datoFiscal);
    };

    // Función para abrir modal en modo NUEVO
    const abrirModalNuevo = () => {
        setFormData({  // ← Limpia el formulario
            idDatoFiscal: 0,
            bIsActive: true,  // <- Valor por defecto para nuevos registros
            vRFC: '',
            vPassword: '',
            vCodeRegimen: '',
            vCP: '',
            vArchivoCER_Base64: null,
            vArchivoCER_Name: '',
            vArchivoKEY_Base64: null,
            vArchivoKEY_Name: '',
            vRazonSocial: '',
            vDescripcionRegimenFiscal: ''
        });
    };

    //Alterna la visibilidad de la contraseña
    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    /**
     * Función para manejar los cambios en los campos
     */
        const handleChange = (e) => {
            const { name, value } = e.target;

            if (name === "vRFC") {
                // Convertir a mayúsculas y filtrar caracteres no permitidos
                const cleanedValue = value.toUpperCase().replace(/[^A-ZÑ&0-9]/g, '');
                const esValido = RFC_REGEX.test(cleanedValue);

                setFormData(prev => ({
                    ...prev,
                    [name]: cleanedValue
                }));

                setRfcValido(esValido);

            } else if (name === "vCP") {
                // Filtra solo números y limita a 6 dígitos
                const numeros = value.replace(/[^0-9]/g, '').slice(0, 6);
                const esValido = CP_REGEX.test(numeros);

                setFormData(prev => ({
                    ...prev,
                    [name]: numeros
                }));

                setCpValido(esValido);

            } else if (name === "vPassword") {
                // Mantener la contraseña tal cual, permitir minúsculas y caracteres especiales
                setFormData(prev => ({
                    ...prev,
                    [name]: value
                }));

            } else {
                // Resto de campos: mantener el texto tal cual (permitir mayúsculas y minúsculas)
                setFormData(prev => ({
                    ...prev,
                    [name]: value
                }));
            }
        };

    //console.log("data", formData)
    //console.log("cpValido", cpValido)
    //console.log("rfcValido", rfcValido)

    //validaciones para RFC y CP
    const RFC_REGEX = /^[A-ZÑ&]{3,4}\d{6}[A-Z0-9]{3}$/;
    const CP_REGEX = /^\d{1,6}$/;

    const validarRFC = (value) => {
        const esValido = RFC_REGEX.test(value);
        setRfcValido(esValido);
        return esValido;
    };

    const handleBlur = (e) => {
        if (e.target.name === "vRFC") {
            setRfcTocado(true);
            validarRFC(e.target.value);
        }
    };
    const handleBlurCP = (e) => {
        if (e.target.name === "vCP") {
            setCpTocado(true);
        }
    };


    /**
     * Obtiene los régimenes fiscales
     */
    const obtenerRegimenesFiscales = async () => {
        
        const response = await fetch("/api/Contabilidad/ObtenerRegimenesFiscales",
            {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            })
            .catch((error) => {
                showErrorToast('Hubo un problema con la peticion Fetch:' + error);
                console.log('Hubo un problema con la peticion Fetch:' + error);

            });

        if (response.ok) {
            console.log("==== OBTENER RÉGIMENES FISCALES ====");

            //console.log("response: ", response);
            const data = await response.json();
            //console.log("dataRF: ", data);

            if (data.iResponseType == 1) {

                var ObjDetalles = JSON.parse(data.detalles);

                //console.log("ObjDetallesRF:", ObjDetalles);

                setRegimenesFiscales(ObjDetalles.table2);

                //console.log("REGIMENES:", ObjDetalles.table2);

                //console.log("REGIMENES set:", regimenesFiscales);

            } else {
                showErrorToast(data.vMessage);
            }

        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
        }
    };

    /**
     * Guarda los cambios realizados en datos fiscales 
     */
    const guardarDatosFiscales = async () => {
        const data = {
            idDatoFiscal:formData.idDatoFiscal,
            //data.vArchivoCER_Base64 = archivoCER.file;
            //data.vArchivoCER_Name = archivoCER.fileName;
            //data.vArchivoKEY_Base64 = archivoKEY.file;
            //data.vArchivoKEY_Name = archivoKEY.fileName;
            vPassword: formData.vPassword,
            vRFC: formData.vRFC,
            vRazonSocial: formData.vRazonSocial,
            vCodeRegimen: formData.vCodeRegimen,
            vDescripcionRegimenFiscal: formData.vDescripcionRegimenFiscal,
            vCP: formData.vCP,
            vArchivoCER_Name: formData.vArchivoCER_Name,
            vArchivoCER_Base64: formData.vArchivoCER_Base64,
            vArchivoKEY_Name: formData.vArchivoKEY_Name,
            vArchivoKEY_Base64: formData.vArchivoKEY_Base64

        }
        //console.log("(INFORMACION MANDADA A ENDOINT) ", data)
        setGuardando(true);

        const response = await fetch("/api/Contabilidad/guardarDatosFiscales",
            {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(data)
            })
            .catch((error) => {
                showErrorToast('Hubo un problema con la peticion Fetch:' + error);
                //console.log('Hubo un problema con la peticion Fetch:' + error);

            }
        );
        if (response.ok) {

           // console.log("==== GUARDA DATOS FISCALES ====");
            //console.log("response (guardarDatosFiscales):", response);
            const data = await response.json();
            //console.log("data OBJRESPONSE (guardarDatosFiscales): ", data);
            setGuardando(false)

            if (data.iResponseType == 1) {

                setEditar(false)
                //var ObjDetalles = JSON.parse(data.detalles);
                //console.log("Obj detalles (guardarDatosFiscales)", ObjDetalles)
                //console.log("Dato fiscal", datoFiscal)
                //console.log("TABLA 2(VER DATOS  guardar)", ObjDetalles.table2);
                setLista(!lista);
                setShowModalDatosFiscales(false);

            } else {
                showErrorToast(data.vMessage);
            }
        }
        else {
            setGuardando(false)
            showErrorToast(response.status + ' ' + response.statusText);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
        }
    };

    /**
     * Selecciona el archivo .key
     * @param {any} e
     */
    const seleccionarArchivoKEY = (e) => {
        const file = e.target.files[0];

        if (file) {
            // Validar extensión del archivo
            if (!file.name.endsWith('.key')) {
                //console.error("Solo se permiten archivos .key.");
                showErrorToast("Solo se permiten archivos .key.");
                return;
            }

            // Validar longitud del nombre del archivo
            if (file.name.length > 50) {
                //console.error("El nombre del archivo excede los 50 caracteres.");
                showErrorToast("El nombre del archivo no debe exceder los 50 caracteres.");
                return;
            }

            // Validar tamaño del archivo (1 MB = 1 * 1024 * 1024 bytes)
            if (file.size > 1 * 1024 * 1024) {
                //console.error("El archivo excede el tamaño máximo permitido de 1 MB.");
                showErrorToast("El archivo no debe pesar más de 1 MB.");
                return;
            }

            const reader = new FileReader();

            reader.onload = () => {
                // Asegúrate de que el resultado no sea null/undefined
                if (reader.result) {
                    const base64 = reader.result.toString().split(',')[1];
                    setFormData(prev => ({
                        ...prev,
                        vArchivoKEY_Name: file.name,
                        vArchivoKEY_Base64: base64,
                        fileKEY: file
                    }));
                }
            };

            reader.onerror = () => {
                //console.error("Error en la lectura del archivo");
                showErrorToast("Error al leer el archivo.");
            };

            reader.readAsDataURL(file);
        }
    };

    /**
 * Selecciona el archivo .cer
 * @param {any} e
 */
    const seleccionarArchivoCER = (e) => {
        const file = e.target.files[0];

        if (file) {
            // Validar extensión del archivo
            if (!file.name.endsWith('.cer')) {
                //console.error("Solo se permiten archivos .cer");
                showErrorToast("Solo se permiten archivos .cer");
                cerFileInput.current.value = ''; // Limpiar input
                return;
            }

            // Validar longitud del nombre del archivo
            if (file.name.length > 50) {
                //console.error("El nombre del archivo excede los 50 caracteres.");
                showErrorToast("El nombre del archivo no debe exceder los 50 caracteres.");
                cerFileInput.current.value = ''; // Limpiar input
                return;
            }

            // Validar tamaño del archivo (1 MB = 1 * 1024 * 1024 bytes)
            if (file.size > 1 * 1024 * 1024) {
                //console.error("El archivo excede el tamaño máximo permitido de 1 MB.");
                showErrorToast("El archivo no debe pesar más de 1 MB.");
                cerFileInput.current.value = ''; // Limpiar input
                return;
            }

            const reader = new FileReader();

            reader.onload = () => {
                // Asegúrate de que el resultado no sea null/undefined
                if (reader.result) {
                    const base64 = reader.result.toString().split(',')[1];
                    setFormData(prev => ({
                        ...prev,
                        vArchivoCER_Name: file.name,
                        vArchivoCER_Base64: base64,
                        fileCER: file
                    }));
                }
            };

            reader.onerror = () => {
                //console.error("Error en la lectura del archivo");
                showErrorToast("Error al leer el archivo.");
            };

            reader.readAsDataURL(file);
        }
    };

    // Estado para el drag and drop
    const [dragging, setDragging] = useState({ cer: false, key: false });

    // Manejador genérico para drag and drop
    const handleDrag = (type, e) => {
        e.preventDefault();
        e.stopPropagation();
        setDragging(prev => ({ ...prev, [type]: e.type === 'dragover' }));
    };

    // Manejador para soltar archivos
    const handleDrop = (type, e) => {
        e.preventDefault();
        setDragging(prev => ({ ...prev, [type]: false }));
        const file = e.dataTransfer.files[0];
        if (file) {
            const handler = type === 'cer'
                ? seleccionarArchivoCER
                : seleccionarArchivoKEY;
            handler({ target: { files: [file] } });
        }
    };

    return (
        <>

            <Modal
                show={showModalDatosFiscales}
                size="lg"
                backdrop="static"
                centered
                keyboard={false}
            >
                <Modal.Header>
                    {   showModalNuevo  ?
                            <Modal.Title>Registrar Datos Fiscales</Modal.Title>
                            :
                            <Modal.Title>Informacion Datos Fiscales</Modal.Title>
                    }
                </Modal.Header>
                    <Modal.Body>
                        <Row className="mb-2">
                            <Col sm={6} xs={12}>
                                <Form.Group>
                                    <Form.Label>
                                        RFC
                                    </Form.Label>
                                        {
                                            showModalNuevo || editar ?
                                                <>
                                                    <Form.Control
                                                        size="sm"
                                                        autoComplete="off"
                                                        name="vRFC"
                                                        type="text"
                                                        value={formData.vRFC || ''}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        className={rfcTocado && !rfcValido ? 'is-invalid' : ''}
                                                        maxLength="13"
                                                    />

                                                    {rfcTocado && !rfcValido && (
                                                        <Form.Control.Feedback type="invalid">
                                                            RFC inválido.
                                                        </Form.Control.Feedback>
                                                    )}       
                                                </>
                                                :
                                                <>
                                                    {
                                                        cargando ?
                                                            <Skeleton />
                                                            :
                                                            <Form.Control
                                                                size="sm"
                                                                type="text"
                                                                value={datoFiscal.vRFC}
                                                                readOnly
                                                            />
                                                    }
                                                </>
                                        }
                                </Form.Group>
                                <Form.Group>
                                    <Form.Label>
                                        Razon Social
                                    </Form.Label>
                                        {
                                            showModalNuevo || editar ?
                                                <>
                                                    <Form.Control
                                                        size="sm"
                                                        autoComplete="off"
                                                        name="vRazonSocial"
                                                        type="text"
                                                        onKeyUp={(event) => { event.target.value = event.target.value.toUpperCase() }}
                                                        value={formData.vRazonSocial}
                                                        onChange={handleChange}
                                                        
                                                    />
                                                </>
                                                :
                                                <>
                                                    {
                                                        cargando ?
                                                            <Skeleton />
                                                            :
                                                            <Form.Control
                                                                size="sm"
                                                                type="text"
                                                                value={datoFiscal.vRazonSocial}
                                                                readOnly
                                                            />
                                                    }
                                                </>
                                        }
                                </Form.Group>
                                <Form.Group>
                                    <Form.Label>
                                        R&eacute;gimen Fiscal
                                    </Form.Label>
                                    {
                                        showModalNuevo || editar ?
                                            <>
                                                <Form.Select
                                                    size="sm"
                                                    aria-label="Default select"
                                                    name = "vCodeRegimen"
                                                    value={formData? formData.vCodeRegimen : ''}
                                                    onChange={handleChange}
                                                    
                                                >
                                                    <option value="">Selecciona un r&eacute;gimen</option>
                                                    {regimenesFiscales.map((regimen, index) => {
                                                        return (
                                                            <option
                                                                key={index}
                                                                value={regimen.vCodigoRegimen}>
                                                                {regimen.vCodigoRegimen} - {regimen.vDescripcionRegimenFiscal}
                                                            </option>)
                                                    })}
                                                </Form.Select>

                                            </>
                                            :
                                            <>
                                                {
                                                    cargando ?
                                                        <Skeleton />
                                                        :
                                                        <Form.Control
                                                            size="sm"
                                                            type="text"
                                                            value={datoFiscal.vCodeRegimen + "-" + datoFiscal.vDescripcionRegimenFiscal}
                                                            readOnly
                                                        />
                                                }
                                            </>
                                    }
                                </Form.Group>
                                <Form.Group>
                                    <Form.Label>
                                        Codigo Postal
                                    </Form.Label>
                                        {
                                            showModalNuevo || editar ?
                                                <>
                                                    <Form.Control
                                                        size="sm"
                                                        autoComplete="off"
                                                        name="vCP"
                                                        type="text"
                                                        value={formData?.vCP || ''}
                                                        onChange={handleChange}
                                                        onBlur={handleBlurCP}
                                                        className={cpTocado && !cpValido ? 'is-invalid' : ''}
                                                        maxLength={6}
                                                    />

                                                    {cpTocado && !cpValido && (
                                                        <Form.Control.Feedback type="invalid">
                                                            Debe contener solo números (máximo 6 dígitos)
                                                        </Form.Control.Feedback>
                                                    )}
                                                </>
                                                :
                                                <>
                                                    {
                                                        cargando ?
                                                            <Skeleton />
                                                            :
                                                            <Form.Control
                                                                size="sm"
                                                                type="text"
                                                                value={datoFiscal.vCP}
                                                                readOnly
                                                            />
                                                    }
                                                </>
                                        }
                                </Form.Group>
                                
                            </Col>

                            <Col sm={6} xs={12}>
                                <Form.Group>
                                    <Form.Label>
                                        Contraseña
                                    </Form.Label>
                                    {
                                    showModalNuevo || editar ?
                                        
                                            <>
                                                <InputGroup>
                                                <Form.Control
                                                    size="sm"
                                                    autoComplete="off"
                                                    name="vPassword"
                                                    type={showPassword ? 'text' : 'password'}
                                                    value={formData ? formData.vPassword : ''}
                                                    onChange={handleChange}

                                                        
                                                        placeholder="Enter your password"
                                                        minLength={8} 
                                                        maxLength={20}
                                                    />
                                                    <Button variant="outline-secondary" onClick={togglePasswordVisibility}>
                                                        <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
                                                    </Button>
                                                </InputGroup>

                                            </>
                                            :
                                            <>
                                                {
                                                    cargando ?
                                                        <Skeleton />
                                                        : 
                                                        <Form.Control
                                                            type='password'
                                                            size="sm"
                                                            value = {datoFiscal.vPassword}
                                                            readOnly
                                                        />
                                                }
                                            </>
                                    }
                                </Form.Group>
                                {/* Apartado para el archivo CER */}
                                {
                                    showModalNuevo || editar ?

                                    <>
                                        <Form.Group className="mb-2">
                                            <Form.Label className="small fw-medium mb-1">
                                                Seleccionar Archivo.CER
                                            </Form.Label>

                                            <div
                                                className={`border border-dashed rounded-2 p-2 ${dragging.cer ? 'border-primary bg-light' : ''
                                                    }`}
                                                onDragOver={(e) => handleDrag('cer', e)}
                                                onDragLeave={(e) => handleDrag('cer', e)}
                                                onDrop={(e) => handleDrop('cer', e)}
                                            >
                                                <input
                                                    type="file"
                                                    id="cerUpload"
                                                    className="d-none"
                                                    onChange={seleccionarArchivoCER}
                                                    accept=".cer"
                                                    ref={cerFileInput}
                                                />

                                                <div className="d-flex align-items-center gap-2">
                                                    <Button
                                                        as="label"
                                                        variant="outline-secondary"
                                                        size="sm"
                                                        className="py-1"
                                                        htmlFor="cerUpload"
                                                    >
                                                        <FontAwesomeIcon icon={faPlus} className="me-1" />
                                                        {formData.vArchivoCER_Name ? 'Reemplazar' : 'Agregar'}
                                                    </Button>

                                                    <div className="text-muted small">
                                                        <FontAwesomeIcon icon={faCloudUploadAlt} className="me-1" />
                                                        Arrastra aquí
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Sección de archivo subido */}
                                            {formData.vArchivoCER_Name && (
                                                <div className="d-flex align-items-center mt-2">
                                                    <FontAwesomeIcon
                                                        icon={faFileContract}
                                                        className="text-primary me-2"
                                                    />
                                                    <span className="small text-truncate">
                                                        {formData.vArchivoCER_Name}
                                                    </span>
                                                    <Button
                                                        variant="link"
                                                        size="sm"
                                                        className="text-danger ps-2 pe-0"
                                                        onClick={() => {
                                                            setFormData(prev => ({
                                                                ...prev,
                                                                vArchivoCER_Name: '',
                                                                vArchivoCER_Base64: '',
                                                                fileCER: null
                                                            }));
                                                            cerFileInput.current.value = '';
                                                        }}
                                                    >
                                                        x
                                                    </Button>
                                                </div>
                                            )}
                                        </Form.Group>
                                    </>
                                    :
                                    <>
                                        {/* Sección de archivo CER (solo visualización) */}
                                        {formData.vArchivoCER_Name && (
                                            <div className="d-flex align-items-center gap-2 mt-2 bg-light rounded p-2">
                                                <FontAwesomeIcon
                                                    icon={faFileContract}
                                                    className="text-primary fs-5"
                                                />
                                                <div className="flex-grow-1">
                                                    <div className="small fw-medium text-truncate">
                                                        {formData.vArchivoCER_Name}
                                                    </div>
                                                    <div className="text-muted extra-small">
                                                        <span className="me-2">Tipo: CER</span>
                                                        <span>Tamaño: {(formData.fileCER?.size / 1024).toFixed(2)} KB</span>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </>
                                }

                                {/* Apartado para el archivo KEY */}
                                {
                                    showModalNuevo || editar ?

                                    <>
                                    <Form.Group className="mb-2">
                                        <Form.Label className="small fw-medium mb-1">
                                            Seleccionar Archivo.KEY
                                        </Form.Label>

                                        <div
                                            className={`border border-dashed rounded-2 p-2 ${dragging.key ? 'border-primary bg-light' : ''
                                                }`}
                                            onDragOver={(e) => handleDrag('key', e)}
                                            onDragLeave={(e) => handleDrag('key', e)}
                                            onDrop={(e) => handleDrop('key', e)}
                                        >
                                            <input
                                                type="file"
                                                id="keyUpload"
                                                className="d-none"
                                                onChange={seleccionarArchivoKEY}
                                                accept=".key"
                                                ref={keyFileInput}
                                            />

                                            <div className="d-flex align-items-center gap-2">
                                                <Button
                                                    as="label"
                                                    variant="outline-secondary"
                                                    size="sm"
                                                    className="py-1"
                                                    htmlFor="keyUpload"
                                                >
                                                    <FontAwesomeIcon icon={faPlus} className="me-1" />
                                                    {formData.vArchivoKEY_Name ? 'Reemplazar' : 'Agregar'}
                                                </Button>

                                                <div className="text-muted small">
                                                    <FontAwesomeIcon icon={faCloudUploadAlt} className="me-1" />
                                                    Arrastra aquí
                                                </div>
                                            </div>
                                        </div>

                                        {/* Sección de archivo subido */}
                                        {formData.vArchivoKEY_Name && (
                                            <div className="d-flex align-items-center mt-2">
                                                <FontAwesomeIcon
                                                    icon={faKey}
                                                    className="text-warning me-2"
                                                />
                                                <span className="small text-truncate">
                                                    {formData.vArchivoKEY_Name}
                                                </span>
                                                <Button
                                                    variant="link"
                                                    size="sm"
                                                    className="text-danger ps-2 pe-0"
                                                    onClick={() => {
                                                        setFormData(prev => ({
                                                            ...prev,
                                                            vArchivoKEY_Name: '',
                                                            vArchivoKEY_Base64: '',
                                                            fileKEY: null
                                                        }));
                                                        keyFileInput.current.value = '';
                                                    }}
                                                >
                                                    x
                                                </Button>
                                            </div>
                                        )}
                                    </Form.Group>
                                    </>
                                    :
                                    <>
                                        {/* Sección de archivo KEY (solo visualización) */}
                                        {formData.vArchivoKEY_Name && (
                                            <div className="d-flex align-items-center gap-2 mt-2 bg-light rounded p-2">
                                                <FontAwesomeIcon
                                                    icon={faKey}
                                                    className="text-warning fs-5"
                                                />
                                                <div className="flex-grow-1">
                                                    <div className="small fw-medium text-truncate">
                                                        {formData.vArchivoKEY_Name}
                                                    </div>
                                                    <div className="text-muted extra-small">
                                                        <span className="me-2">Tipo: KEY</span>
                                                        <span>Tamaño: {(formData.fileKEY?.size / 1024).toFixed(2)} KB</span>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </>
                            }
                            </Col>
                        </Row>
                    </Modal.Body>

                    {/*Apartado para los botones*/ }
                    <Modal.Footer>
                         {
                            showModalNuevo ?
                                <>
                                    <Button
                                        onClick={(e) => {
                                        e.preventDefault(); setShowModalDatosFiscales(false);
                                        }}

                                        variant="falcon-danger "
                                        size="sm"
                                        transform="shrink-2"
                                        className="d-sm-block me-2"
                                    >
                                        <span className=" ms-1">X Cancelar</span>
                                    </Button>
                                    <Col className="col-auto">
                                        {
                                            guardando ?
                                                <>
                                                    {/* mostrar boton como "cargando" */}
                                                    <Button
                                                        variant="falcon-default"
                                                        size="sm"
                                                        transform="shrink-2"
                                                        className="d-sm-block me-2"
                                                        disabled
                                                    >
                                                        <Spinner className="text-inline" animation="border" size="sm" variant="ligth" />&nbsp; Cargando...
                                                    </Button>
                                                </>
                                                :
                                                <>
                                                    <IconButton
                                                    variant="falcon-default"
                                                    size="sm"
                                                    icon="check"
                                                    transform="shrink-2"
                                                    className="d-sm-block me-2"
                                                    onClick={guardarDatosFiscales}
                                                    disabled={
                                                        !rfcValido ||
                                                        !cpValido ||
                                                        formData.vRFC == '' ||
                                                        formData.vRazonSocial == '' ||
                                                        formData.vCodeRegimen == '' ||
                                                        formData.vCP == ''
                                                    }
                                                    >
                                                        <span className=" ms-1">Guardar</span>
                                                    </IconButton>
                                                </>
                                        }

                                    </Col>
                                </>
                                :
                                <>
                                     {
                                        editar ?
                                            <>
                                                <Col className="col-auto">
                                                    <Button
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            if (editar) {
                                                                setShowModalDatosFiscales(false);
                                                            }
                                                        }}
                                                        variant="falcon-danger"
                                                        size="sm"
                                                        transform="shrink-2"
                                                        className="d-sm-block me-2"
                                                    >
                                                        <span className="d-none d-xl-inline-block ms-1">X Cancelar</span>
                                                    </Button>
                                                </Col>
                                                <Col className="col-auto">
                                                    {
                                                        guardando ?
                                                            <>
                                                                {/* mostrar boton como "cargando" */}
                                                                <Button
                                                                    variant="falcon-default"
                                                                    size="sm"
                                                                    transform="shrink-2"
                                                                    className="d-sm-block me-2"
                                                                    disabled
                                                                >
                                                                    <Spinner className="text-inline" animation="border" size="sm" variant="ligth" />&nbsp; Cargando...
                                                                </Button>
                                                            </>
                                                            :
                                                            <>
                                                                <IconButton
                                                                    variant="falcon-default"
                                                                    size="sm"
                                                                    icon="check"
                                                                    transform="shrink-2"
                                                                    className="d-sm-block me-2"
                                                                    onClick={guardarDatosFiscales}
                                                                    disabled={
                                                                        !rfcValido ||
                                                                        !cpValido ||
                                                                        formData.vRFC == '' ||
                                                                        formData.vRazonSocial == '' ||
                                                                        formData.vCodeRegimen == '' ||
                                                                        formData.vCP == '' 
                                                                    }
                                                                >
                                                                    <span className=" ms-1">Guardar</span>
                                                                </IconButton>
                                                            </>
                                                    }

                                                </Col>
                                            </>      
                                            :
                                            <>
                                                <Col className="col-auto">
                                                    <Button
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            setShowModalDatosFiscales(false);
                                                        }}

                                                        variant="falcon-danger "
                                                        size="sm"
                                                        transform="shrink-2"
                                                        className="d-sm-block me-2"
                                                    >
                                                        <span className="d-none d-xl-inline-block ms-1">X Cancelar</span>
                                                    </Button>
                                                </Col>
                                                <Col className="col-auto">
                                                    <IconButton
                                                        onClick={(e) => { e.preventDefault(); setEditar(true) }}

                                                        variant="falcon-default"
                                                        size="sm"
                                                        icon="pencil-alt"
                                                        transform="shrink-2"
                                                        className="d-sm-block me-2"
                                                    >
                                                        <span className="d-none d-xl-inline-block ms-1">Editar</span>
                                                    </IconButton>
                                                </Col>
                                            </>
                                     }
                                </>
                         }
                    </Modal.Footer>
            </Modal>

        </>
    );
};

ModalDatosFiscales.propTypes = {

    setShowModalNuevo: PropTypes.func,
    showModalNuevo: PropTypes.bool,
    showModalDatosFiscales: PropTypes.bool, 
    setShowModalDatosFiscales: PropTypes.func,

    datoFiscal: PropTypes.object,
    setLista: PropTypes.func,
    lista: PropTypes.bool
};

export default ModalDatosFiscales;